import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../app/api/routes';
import { ANONYMIZE_IDENTITY_RESOURCE, IDENTITIES_RESOURCE } from '../constants';

const AnonymizeIdentityService = ComposedComponent =>
  reduxFetch([
    {
      resource: ANONYMIZE_IDENTITY_RESOURCE,
      method: 'post',
      request: (identityId, identity, callback, t) => ({
        url: apiRoutes.anonymizeIdentity(identityId),
        meta: {
          callback,
          updateOtherList: {
            resource: IDENTITIES_RESOURCE,
            idProp: 'id',
            id: identityId,
            values: {
              fullName: `Removed user ${identityId}`,
              emailAddress: `${identityId}@nallian.invalid`,
              phoneNumber: null,
              isActive: false,
            },
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'anonymizeIdentityFailed'),
            onSuccessMessage: t('anonymizeIdentitySuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default AnonymizeIdentityService;
